<template>
  <v-layout row wrap>
    <v-toolbar dark color="primary">
      <v-toolbar-title>{{projectStatus}} Project Summary</v-toolbar-title>
    </v-toolbar>
    <v-layout row v-if="headers">
      <v-flex xs12 pt-5>
        <v-data-table :headers="headers" :items="tableData" class="elevation-1" :rows-per-page-items="[10,25,100]">
          <template slot="headerCell" slot-scope="props">
            <v-layout row wrap align-end justify-center>
              <span :class="props.header.text === 'Project' ? 'projectHeaders' : ['vtableHeaders', 'text-xs-center']" slot="activator">{{ props.header.text }}</span>
            </v-layout>
          </template>
          <template slot="items" slot-scope="props">
            <tr>
              <td @click="index === 0 ? openProject(props.item) : openTask({item: props.item, index: index})" :style="props.item[column.text] ? 'cursor: pointer' : ''" :class="index === 0 ? 'projectText' : 'tableText'" align="center" :bgcolor="statusColors(props.item[column.text])" v-for="(column, index) in headers" :key="index">{{ props.item[column.text] }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <!-- Task Dialog Box -->
    <v-dialog v-if="editTaskDialog" v-model="editTaskDialog" width="800px" content-class="white">
      <edit-task @addNote="addNote" @closeTaskDialog="editTaskDialog = false" @completeTask="completeTask" @changeTaskStatus="changeTaskStatus" :project="project" :projectGrid="true" :taskName="selectedTask.name" :projectNotes="projectNotes" />
    </v-dialog>
    <!-- End: Task Dialog Box -->
  </v-layout>
</template>


<script>
import EditTask from '../tasks/EditTask'
import _ from 'lodash'

export default {
  props: ['projectStatus'],
  data () {
    return {
      selectedTask: null,
      editTaskDialog: false,
      selectedTaskId: null,
      project: null
    }
  },
  watch: {
    // project () {
    //   this.getProjectTasks()
    // }
  },
  mounted () {
    this.$store.dispatch('getTaskOnReport', this.projectStatus)
    // const payload = {status: this.projectStatus, projectFilters: 'Active', tasks: true}
    this.$store.dispatch('getProjectList', {status: this.projectStatus, projectFilters: 'Active', tasks: false})
    // this.getSummaryData(this.projectStatus)
  },
  computed: {
    headers () {
      const getPhases = this.$store.getters.tasksOnReport
      let phases = [{text: 'Project', value: 'project', sortable: true}]
      getPhases.forEach(phase => {
        phases.push({text: phase, class: 'text-xs-center', sortable: false, width: '300px'})
      })
      return phases
    },
    tableData () {
      let data = []
      this.summaryData.forEach(project => {
        if (project.tasks && project.tasks.length > 0) {
          let statusData = null
          this.headers.forEach(header => {
            const index = project.tasks.findIndex(i => i.name === header.text)
            if (header.text === 'Project') {
              statusData = {...statusData, [header.text]: project.name}
            } else if (project.tasks[index]) {
              if (project.tasks[index].due_date.seconds < new Date().getTime() / 1000 && project.tasks[index].status !== 'Completed' && project.tasks[index].status !== 'Flagged' && project.tasks[index].status !== 'On Hold' && project.tasks[index].status !== 'Not Applicable') {
                statusData = {...statusData, [header.text]: 'Past Due'}
              } else {
                statusData = {...statusData, [header.text]: project.tasks[index].status}
              }
            } else {
              statusData = {...statusData, [header.text]: null}
            }
          })
          data.push({project: project.name, ...statusData})
        }
      })
      return data
    },
    summaryData () {
      let getProjects = Object.assign([], this.$store.getters.projectList)
      let projects = []
      // Filter Completed vs Active
      getProjects.forEach(project => {
        let tasks = []
        let totalTasks = 0
        let completedTasks = 0
        let pastDueTasks = 0
        if (project.tasks && !project.revertedToLeads) {
          const taskIds = Object.keys(project.tasks)
          totalTasks = taskIds.length
          taskIds.forEach(task => {
            tasks.push({...project.tasks[task], id: task})
            if (project.tasks[task].status === 'Completed' || project.tasks[task].status === 'Not Applicable') {
              completedTasks++
            }
            if (project.tasks[task].due_date && project.tasks[task].status !== 'Completed' && project.tasks[task].status !== 'Not Applicable' && project.tasks[task].due_date.seconds < new Date().getTime() / 1000) {
              pastDueTasks++
            }
          })
          project.tasks = tasks
          const progress = totalTasks === 0 || completedTasks === 0 ? 0 : Math.round(completedTasks / totalTasks * 100)
          projects.push({...project, totalTasks, completedTasks, pastDueTasks, progress})
        } else if (!project.revertedToLeads) {
          projects.push({...project, totalTasks: 0, completedTasks: 0, progress: 0, pastDueTasks: 0})
        }
      })
      return projects
    },
    projectNotes () {
      const getNotes = this.$store.getters.projectNotes
      const users = this.$store.getters.userList.concat(this.$store.getters.inactiveUsers)
      let notes = []
      getNotes.forEach(note => {
        const user = users.filter(f => f.id === note.created_by)
        notes.push({...note, avatar: user[0].avatar, userFullName: user[0].first_name + ' ' + user[0].last_name})
      })
      return _.orderBy(notes, 'created_date', ['desc'])
    }
  },
  methods: {
    completeTask (payload) {
      const projectIndex = this.tableData.findIndex(i => i.project === payload.projectName)
      this.tableData[projectIndex][payload.taskName] = 'Completed'
    },
    changeTaskStatus (payload) {
      this.selectedTask.status = payload.status
    },
    openTask (item) {
      const projectIndex = this.summaryData.findIndex(i => i.name === item.item.project)
      this.project = Object.assign({}, this.summaryData[projectIndex])
      const objToArray = Object.keys(item.item)
      const taskIndex = this.project.tasks.findIndex(i => i.name === objToArray[item.index + 1])
      this.selectedTask = this.project.tasks[taskIndex]
      this.editTaskDialog = true
    },
    openProject (item) {
      // Get Project ID
      const index = this.summaryData.findIndex(i => i.name === item.project)
      const projectId = this.summaryData[index].id
      this.$router.push('/project/' + projectId)
    },
    statusColors (status) {
      if (status === 'Flagged') {
        return this.$vuetify.theme.Flagged
      } else if (status === 'Completed') {
        return this.$vuetify.theme.Completed
      } else if (status === 'Not Applicable') {
        return this.$vuetify.theme.secondary
      } else if (status === 'On Hold') {
        return this.$vuetify.theme.OnHold
      } else if (status === 'Past Due') {
        return this.$vuetify.theme.PastDue
      } else if (status === 'Not Started') {
        return this.$vuetify.theme.NotStarted
      } else if (status === 'Started') {
        return this.$vuetify.theme.Started
      }
    },
    addNote (task) {
      const note = task.note ? task.note : this.newNote
      if (note) {
        let payload = {project_id: this.project.id, note: note, project_name: this.project.name, task_id: task.task_id, task_name: task.task_name}
        this.$store.dispatch('addProjectNote', payload)
        this.newNote = null
        this.showNoteForm = false
      }
    }
    // getSummaryData (status) {
    //   this.$store.dispatch('getSummaryData', {status: status}) // Status: Project Status
    // }
  },
  components: {
    EditTask
  }
}
</script>

<style scoped>
/* table.v-table,
  table.table {
  } */
.projectText {
  font-size: 16px;
  font-weight: 900;
  color: black;
}
.tableText {
  font-size: 12px;
  font-weight: 900;
  color: white;
  border: 1px solid grey;
}
.projectHeaders {
  font-weight: 900;
  font-size: 16px;
  width: 200px;
}
.vtableHeaders {
  white-space: normal;
  font-weight: 900;
  font-size: 16px;
  margin: 0px;
  justify-content: center;
  /* -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); */
}
th,
td {
  padding: 0 !important;
}
</style>





// WEBPACK FOOTER //
// src/components/reports/ProjectGrid.vue